import React from "react";
import {
  resetAlertFilters,
  setPreviousReport,
  setPreviousReportPdfUrl,
  setSelectedAlert,
  toggleModal,
} from "app/store/transmission/slice/transmissionSlice";
import { useDispatch, useSelector } from "react-redux";

import { Chip, IconButton, Modal, Paper } from "@mui/material";
import PdfViewer from "../../viewer/PdfViewer";

import formatDate from "utils/formatDate";
import { Close as CloseIcon } from "@mui/icons-material";
import { capitalizeFirstLetterOfEachWord } from "utils/string";

const PdfModal = ({ launchSnackbarMessage }) => {
  const { isPdfModal, previousReportId, reportDate, selectedAlert } =
    useSelector((state) => state.transmission);

  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(toggleModal({ type: "pdfModal", value: false }));
    dispatch(resetAlertFilters());
    dispatch(setSelectedAlert(""));
    dispatch(setPreviousReport(""));
    dispatch(setPreviousReportPdfUrl(null));
  };

  return (
    <Modal open={isPdfModal} onClose={onClose}>
      <Paper className="report-note-pdf-modal">
        <div className="report-note-pdf-modal-header">
          <div className="report-note-pdf-modal-header__title">
            {`Report - ${formatDate(reportDate, "MM/DD/YYYY")}`}
            {selectedAlert && (
              <Chip
                size="small"
                label={`${capitalizeFirstLetterOfEachWord(
                  selectedAlert?.title
                )}: ${selectedAlert?.description} | Page: ${
                  selectedAlert?.pageNumber
                }`}
                className="report-note-pdf-modal-header__title-chip"
              />
            )}
          </div>
          <IconButton
            className="p-1"
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div className="report-note-pdf-modal-content">
          {previousReportId && (
            <PdfViewer
              reportId={previousReportId}
              launchSnackbarMessage={launchSnackbarMessage}
              isPreviousReport={true}
            />
          )}
        </div>
      </Paper>
    </Modal>
  );
};

export default PdfModal;
